import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../../../shared-zorro.module';
import { RouterModule } from '@angular/router';
import { RenderComponent } from '../../../component/template/render/render.component';
import { UserService } from '../../../../service/user.service';
import { NzContextMenuService } from 'ng-zorro-antd/dropdown';
import { NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd/tree';
import { NzTreeComponent } from 'ng-zorro-antd/tree';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-diagnosis',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule, RenderComponent],
  templateUrl: './diagnosis.component.html',
  styleUrl: './diagnosis.component.less',
})
export class DiagnosisComponent implements AfterViewInit {
  @ViewChild('findingPreview') findingPreview!: ElementRef;
  @ViewChild('conclusionPreview') conclusionPreview!: ElementRef;
  // nzTreeComponent
  @ViewChild('nzTreeComponent') nzTreeComponent!: NzTreeComponent;
  findingContent: string = '';
  conclusionContent: string = '';
  templateName: string = '';
  scanMethod: string = '';
  preview: any = {
    finding: [],
    conclusion: [],
  };
  report: any = {
    finding: '',
    conclusion: '',
  };
  partsArray: any[] = [];
  reportValue: any[] = [];
  templateType: string = 'SYSTEM'; //system,hospital,personal
  nodes: NzTreeNode[] = [];
  selectedNode: any = null;
  folderType: string = 'folder'; //folder,item
  folderName: string = '';
  expandedKeys: any[] = [];
  keyword: string = '';
  constructor(private userService: UserService, private nzContextMenuService: NzContextMenuService, private modal: NzModalService, private message: NzMessageService) {}

  ngAfterViewInit() {
    // 确保在视图初始化后操作 DOM
    this.updatePreview();
    this.getTemplate();
  }

  updatePreview() {
    this.preview = this.parseTemplate(this.findingContent, this.conclusionContent);
  }

  contentChange() {
    this.updatePreview();
  }

  search() {
    this.getTemplate();
  }

  reset() {
    this.keyword = '';
    this.getTemplate();
  }

  //解析内容
  parseTemplate(findingContent: string, conclusionContent: string) {
    this.partsArray = [];
    let findingParts: any[] = [];
    let conclusionParts: any[] = [];
    if (findingContent === '') {
      findingParts = [];
    } else {
      findingParts = this.getParts(findingContent, this.partsArray);
    }
    if (conclusionContent === '') {
      conclusionParts = [];
    } else {
      conclusionParts = this.getParts(conclusionContent, this.partsArray);
    }
    return { finding: findingParts, conclusion: conclusionParts };
  }

  getParts(content: string, partsArray: any[]) {
    let parts: any = [];
    // 正则表达式匹配 [选项1/选项2] 和 [_] 以及 [@]
    const regex = /\[([^\]]+)]|(_)|(@)/g;
    parts = content.match(/[^[]+|\[[^\]]+\]/g);
    let result: any[] = [];
    parts.forEach((item: any) => {
      if (item.match(/\[[^\]]+\/[^\]]+\]/)) {
        let obj = {
          type: 'select',
          content: item,
          options: item.slice(1, -1).split('/'),
          index: partsArray.length,
        };
        partsArray.push(obj);
        result.push(obj);
      } else if (item.match(/\[_]/)) {
        let obj = {
          type: 'input',
          content: item,
          index: partsArray.length,
        };
        partsArray.push(obj);
        result.push(obj);
      } else if (item.match(/\[@\d+\]/)) {
        let obj = {
          type: 'reference',
          content: item,
          index: partsArray.length,
          vIndex: Number(item.match(/\d+/)[0] - 1),
        };
        partsArray.push(obj);
        result.push(obj);
      } else {
        let obj = {
          type: 'text',
          content: item,
        };
        result.push(obj);
      }
    });
    return result;
  }

  //渲染模板
  // renderTemplate(parts: any[], container: HTMLElement, type: string) {
  //   console.log(parts);
  //   container.innerHTML = ''; // 清空容器内容
  //   let partsArray: any[] = [];
  //   for (let i = 0; i < parts.length; i++) {
  //     // 如果匹配到 [选项1/选项2] 则添加选项
  //     if (parts[i].match(/\[[^\]]+\/[^\]]+\]/)) {
  //       partsArray.push(parts[i]);
  //       let index = partsArray.indexOf(parts[i]);
  //       container.innerHTML += `<select id="${type}-${index}" [(ngModel)]="preview.${type}[${index}]" class="template-select" placeholder="请选择" (ngModelChange)="contentChange()">${parts[i]
  //         .slice(1, -1)
  //         .split('/')
  //         .map((option: any) => `<option>${option}</option>`)
  //         .join('')}</select> <sup>[${index + 1}]</sup> `;
  //       // 再加上右上角数字
  //     } else if (parts[i].match(/\[_\]/)) {
  //       partsArray.push(parts[i]);
  //       let index = partsArray.indexOf(parts[i]);
  //       container.innerHTML += `<input type="text" id="${type}-${index}" [(ngModel)]="preview.${type}[${index}]" class="template-input" placeholder="请输入" (ngModelChange)="contentChange()" /> <sup>[${index + 1}]</sup> `;
  //     } else if (parts[i].match(/\[@\d+\]/)) {
  //       partsArray.push(parts[i]);
  //       let index = partsArray.indexOf(parts[i]);
  //       let vIndex = Number(parts[i].match(/\d+/)[0] - 1);
  //       container.innerHTML += `<span class="template-reference">${this.preview[type][vIndex]}</span><sup>[${index + 1}]</sup>`;
  //     } else {
  //       container.innerHTML += `<span class="template-text">${parts[i]}</span>`;
  //     }
  //   }
  // }

  addOption(type: string, option: string) {
    if (type === 'finding') {
      this.findingContent = this.insertContent('findingContent', option);
    } else {
      this.conclusionContent = this.insertContent('conclusionContent', option);
    }
    this.contentChange();
  }

  //插入内容并且不失去焦点
  insertContent(domID: any, content: string) {
    let dom: any = document.getElementById(domID);
    let start = dom.selectionStart;
    let end = dom.selectionEnd;
    let value = dom.value;
    let before = value.slice(0, start);
    let after = value.slice(end);
    dom.value = before + content + after;
    dom.selectionStart = start + content.length;
    dom.selectionEnd = start + content.length;
    dom.focus();
    return dom.value;
  }

  onValueChange(value: any, type: string) {
    if (type === 'finding') {
      this.report.finding = value;
    } else {
      this.report.conclusion = value;
    }
  }

  reportValueChange(value: any) {
    this.reportValue = value;
  }

  selectTab(type: string) {
    this.templateType = type;
    this.keyword = '';
    this.getTemplate();
  }

  //获取模板
  getTemplate() {
    this.userService.getTemplate({ kind: this.templateType, kw: this.keyword }).subscribe((res: any) => {
      let title = this.templateType === 'SYSTEM' ? '系统模板' : this.templateType === 'HOSPITAL' ? '医院模板' : '个人模板';
      let nodes = new NzTreeNode({
        title: title,
        key: '0',
        children: res.data || [],
      });
      this.nodes = [nodes];
      this.expandedKeys = [nodes.key];
    });
  }

  //打开文件夹
  openFolder(event: any) {
    console.log(event);
  }

  selectDropdown(type: string): void {
    // do something
  }

  contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.nzContextMenuService.create($event, menu);
  }

  selectNode(event: any) {
    if (event.node.origin.isLeaf) {
      this.editItem(event.node);
    }
  }

  editItem(node: any) {
    // this.message.info('当前编辑词条为：' + node.origin.name);
    this.selectedNode = node;
    this.findingContent = node.origin.finding || '';
    this.conclusionContent = node.origin.conclusion || '';
    this.templateName = node.origin.name || '词条名称';
    this.scanMethod = node.origin.scanMethod || '';
    this.contentChange();
  }

  copyItem(node: any) {
    let params = {
      categoryName: node.origin.name + '副本',
      finding: node.origin.finding,
      conclusion: node.origin.conclusion,
      templateName: node.origin.name + '副本',
      scanMethod: node.origin.scanMethod,
      parentId: node.origin.parentId,
      sort: (node.origin.sort || 0) + 1,
      reportTemplateCategoryKind: this.templateType,
      isLeaf: node.origin.isLeaf,
    };
    this.userService.addNode(params).subscribe((res: any) => {
      this.message.success('复制成功');
      this.expandNode();
    });
  }

  deleteItem(node: any) {
    this.modal.confirm({
      nzTitle: '确定要删除吗？',
      nzContent: '删除后将无法恢复',
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        this.userService.deleteTemplate({ id: node.origin.id }).subscribe((res: any) => {
          this.message.success('删除成功');
          node.remove();
          this.clearTemplate();
        });
      },
    });
  }

  //清空模板
  clearTemplate() {
    this.findingContent = '';
    this.conclusionContent = '';
    this.templateName = '';
    this.scanMethod = '';
    this.contentChange();
  }

  addFolder(node: any, templateRef: any) {
    this.folderName = '';
    // 打开一个模态框，输入文件夹名称，然后添加到nodes中
    this.modal.create({
      nzTitle: '增加目录',
      nzContent: templateRef,
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        let params = {
          categoryName: this.folderName,
          parentId: node.origin.id || 0,
          sort: 0,
          reportTemplateCategoryKind: this.templateType,
          isLeaf: this.folderType === 'folder' ? false : true,
        };
        this.userService.addNode(params).subscribe((res: any) => {
          this.message.success('增加成功');
          this.expandNode();
        });
      },
    });
  }

  saveTemplate() {
    let params = {
      categoryName: this.templateName,
      id: this.selectedNode.origin.id,
      finding: this.findingContent,
      conclusion: this.conclusionContent,
      templateName: this.templateName,
      scanMethod: this.scanMethod,
      parentId: this.selectedNode.origin.parentId,
      sort: 0,
      reportTemplateCategoryKind: this.templateType,
      isLeaf: true,
    };
    this.userService.addNode(params).subscribe((res: any) => {
      this.message.success('保存成功');
      this.expandNode();
    });
  }

  //更新后并展开指定节点
  expandNode() {
    let expandedKeys = this.nzTreeComponent.getExpandedNodeList().map((item: any) => item.origin.key);
    this.userService.getTemplate({ kind: this.templateType }).subscribe((res: any) => {
      let title = this.templateType === 'SYSTEM' ? '系统模板' : this.templateType === 'HOSPITAL' ? '医院模板' : '个人模板';
      let nodes = new NzTreeNode({
        title: title,
        key: '0',
        children: res.data || [],
      });
      this.nodes = [nodes];
      this.expandedKeys = expandedKeys;
    });
  }

  canSaveTemplate() {
    return this.templateName && this.findingContent && this.conclusionContent;
  }
}
